import { useCallback } from 'react';
import { htcmdService } from 'js/services/htcmd.service';
import { openWindow, openNewWindow } from 'js/utils/url.util';
import { useShowNotification } from 'js/components/common/Notifications';
import { useComponentConfig, useComponentTranslations } from 'js/hooks/component';

import { verifyNow } from '../server';
import { OPEN_IN } from '../constants';

export const useOpenTruNarrative = ({ windowRef, setIframeSrc, setIsUrlLoading, setTruNarrativeError }) => {
    const translate = useComponentTranslations();
    const showNotification = useShowNotification();
    const { openIn, documentType } = useComponentConfig();

    return useCallback(async () => {
        setIsUrlLoading(true);
        setTruNarrativeError('');

        try {
            const handlePopupBlocker = () => showNotification({ message: translate('popupBlocker') });
            const { data: { redirectURL } } = await verifyNow({ documentType });

            if (htcmdService.isEnabled || htcmdService.isWrapperEnabled) {
                htcmdService.openCustomTab(redirectURL);

                return;
            }

            windowRef.current?.close();

            switch (openIn) {
                case OPEN_IN.NEW_TAB:
                    windowRef.current = openWindow(redirectURL, 'TruNarrative', '', handlePopupBlocker);
                    break;
                case OPEN_IN.NEW_WINDOW:
                    windowRef.current = openNewWindow(redirectURL, 'TruNarrative', undefined, handlePopupBlocker);
                    break;
                case OPEN_IN.IFRAME:
                    setIframeSrc(redirectURL);
                    break;
                default:
                    break;
            }
        } catch (error) {
            setTruNarrativeError(translate('error'));
        } finally {
            setIsUrlLoading(false);
        }
    }, [
        openIn, windowRef, translate, documentType, setIframeSrc,
        setIsUrlLoading, showNotification, setTruNarrativeError
    ]);
};
